import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { DriverService } from '../../services/driver-service/driver.service';

@Component({
  selector: 'app-driver-vehicles-dialog',
  templateUrl: './driver-vehicles-dialog.component.html',
  styleUrls: ['./driver-vehicles-dialog.component.css']
})
export class DriverVehiclesDialogComponent implements OnInit {
  driver;
  vehicle = -1;
  vehicles = []
  constructor(private driverService: DriverService, private dialog: MatDialog, public dialogRef: MatDialogRef<DriverVehiclesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.driver = data;
  }

  ngOnInit() {
    this.driverService.getVehicles(this.driver.driverid).then((res) => {
      this.vehicles = res.data;
    })
  }

  assign() {
    if (!this.vehicle || this.vehicle === -1) {
      return;
    }
    var payload = {
      "tripid": this.driver.tripid,
      "vehicleid": this.vehicle,
      "driverid": this.driver.driverid
    }
    this.dialogRef.close(payload);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/driver-vehicles-dialog/driver-vehicles-dialog.component.ts